import React from "react";
import { Outlet } from "react-router-dom";
import { NavMenu } from "./components/NavMenu";

import "./custom.css";
import "./assets/fstyr-theme.scss";
import "dkfds/dist/css/dkfds.css";

export default function App(props) {
  return (
    <>
      <NavMenu isPolice={props.params.isPolice} isAuthenticated={props.params.isAuthenticated} userName={props.params.userName} />
      <Outlet />
    </>
  );
}
